import {
  USER_FRUI_QPFJ_MODAL_CHANGE,
} from './constants';

export function frui_qpfjModalChange(visible,type) {
  return {
    type: USER_FRUI_QPFJ_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_QPFJ_MODAL_CHANGE:
      return {
        ...state,
        frui_qpfjModalType:action.data.type,
        frui_qpfjModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_qpfjModalChange.js